/**
 * PDP mobile gallery dots, Instagram-style, once there are many slides
 * (customer photos): only VISIBLE dots show at a time. The active dot moves
 * through them, and the window slides on only when it reaches the window's
 * second-to-last dot going forward (second going back), so the indicator
 * visibly travels however many slides there are. A window edge with more
 * slides beyond it gets a smaller dot. Fewer than WINDOW_FROM slides keep
 * one dot each.
 *
 * The dots are Slick's (bundled in theme.js, not reachable from here): this
 * only follows the .slick-active class Slick moves between them, and the
 * markup the UGC toggle rebuilds (assets/ugc-gallery-toggle.js).
 * Styles: assets/custom.css (.slick-dots.is-windowed).
 */
(function () {
  'use strict';

  var SECTION_SELECTOR = '[data-section-type="main-product-rocket"]';
  var DOTS_SELECTOR = '.product-detail .gallery .slick-dots';
  var WINDOW_FROM = 10;
  var VISIBLE = 6;

  function update(list) {
    var dots = list.children;
    var count = dots.length;
    var windowed = count >= WINDOW_FROM;
    list.classList.toggle('is-windowed', windowed);
    if (!windowed) return;

    var active = -1;
    for (var i = 0; i < count; i++) {
      if (dots[i].classList.contains('slick-active')) active = i;
    }
    if (active < 0 || (active === list._dotsActive && count === list._dotsCount)) return;
    list._dotsActive = active;
    list._dotsCount = count;

    var start = list._dotsStart || 0;
    if (active > start + VISIBLE - 2) start = active - (VISIBLE - 2);
    if (active < start + 1) start = active - 1;
    start = Math.max(0, Math.min(start, count - VISIBLE));
    list._dotsStart = start;

    for (var j = 0; j < count; j++) {
      var inWindow = j >= start && j < start + VISIBLE;
      var edge =
        inWindow &&
        ((j === start && start > 0) || (j === start + VISIBLE - 1 && start + VISIBLE < count));
      dots[j].classList.toggle('is-in-window', inWindow);
      dots[j].classList.toggle('is-edge', edge);
    }
  }

  function init() {
    var section = document.querySelector(SECTION_SELECTOR);
    if (!section) return;

    var queued = false;
    var scan = function () {
      queued = false;
      section.querySelectorAll(DOTS_SELECTOR).forEach(update);
    };

    // Slick moves .slick-active on every slide change, and the gallery's
    // markup is rebuilt when the UGC toggle swaps media: follow both.
    new MutationObserver(function () {
      if (queued) return;
      queued = true;
      requestAnimationFrame(scan);
    }).observe(section, { subtree: true, childList: true, attributes: true, attributeFilter: ['class'] });

    scan();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
